// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"794":"Luis","795":"LanguageStudio"}[chunkId] || chunkId) + ".min.css";
};